<template>
  <div class="chart">
    <div class="chartline" :style="'width:' + originCodeArr.length * 600 + 'px;'" v-for="(item, key) in codeArr"
      :key="key">
      <el-card class="box-card" v-for="(element, index) in item" :key="index">
        <div slot="header" class="clearfix">
          <span class="title bold">{{ element }} </span>
          <el-button class="btn-top" type="text" @click="delCode(key, index)" icon="el-icon-delete"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="moveBottom(key, index)"
            icon="el-icon-d-arrow-right"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="moveTop(key, index)" icon="el-icon-d-arrow-left"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="moveRight(key, index)" icon="el-icon-right"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="moveLeft(key, index)" icon="el-icon-back"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="moveDown(key, index)" icon="el-icon-bottom"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="moveUp(key, index)" icon="el-icon-top"></el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="copyLine(key)">复制行</el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
          <el-button class="btn-top" type="text" @click="copyAll()">复制所有</el-button>
          <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        </div>
        <div class="card-content">
          <el-image :src="`https://image.sinajs.cn/newchart/daily/n/${code2market(element) + element}.gif`"></el-image>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    codes: {}
  },
  data() {
    return {
      codeArr: [[]],
      originCodeArr: []
    }
  },
  methods: {
    // 6位股票代码加sh/sz前缀，兼容指数
    code2market(code) {
      const indexArr = ['000001', '000688', '000300', '000016']  //沪市指数但开头不是6的code，要特殊处理
      if (indexArr.indexOf(code) >= 0)
        return 'sh' //沪市指数但开头不是6
      else if (code.substr(0, 1) == '8')
        return 'bj' //北交所
      else if (code.substr(0, 1) == '6')
        return 'sh' //沪市
      else if (code.substr(0, 1) == '5')
        return 'sh' //51、56是沪基，其它5开头也都按沪市处理
      else if (code.substr(0, 2) == '11')
        return 'sh' //沪可转债
      else if (code.substr(0, 1) == '0')
        return 'sz' //深市
      else if (code.substr(0, 1) == '3')
        return 'sz' //创业板
      else if (code.substr(0, 2) == '15')
        return 'sz' //深基
      else if (code.substr(0, 2) == '12')
        return 'sz' //深可转债
      else
        return 'sz' //其它按深市处理
    },
    delCode(key, index) {
      console.log(key, index)
      this.codeArr[key].splice(index, 1)
    },
    moveTop(key, index) {
      console.log(key, index)
      let newFlag = 0
      const target = this.codeArr[key].splice(index, 1)[0]
      this.codeArr[key].splice(newFlag, 0, target)
      console.log(this.codeArr)
    },
    moveBottom(key, index) {
      console.log(key, index)
      let newFlag = this.codeArr[key].length - 1
      const target = this.codeArr[key].splice(index, 1)[0]
      this.codeArr[key].splice(newFlag, 0, target)
      console.log(this.codeArr)
    },
    moveRight(key, index) {
      console.log(key, index)
      let newFlag = index + 1
      if (newFlag >= this.codeArr[key].length) newFlag = this.codeArr[key].length - 1
      const target = this.codeArr[key].splice(index, 1)[0]
      this.codeArr[key].splice(newFlag, 0, target)
      console.log(this.codeArr)
    },
    moveLeft(key, index) {
      console.log(key, index)
      let newFlag = index - 1
      if (newFlag < 0) newFlag = 0
      const target = this.codeArr[key].splice(index, 1)[0]
      this.codeArr[key].splice(newFlag, 0, target)
      console.log(this.codeArr)
    },
    moveDown(key, index) {
      console.log(key, index)
      if (key + 1 >= this.codeArr.length) {//新建行
        this.codeArr.push([])
      }
      const target = this.codeArr[key].splice(index, 1)[0]
      console.log(target)
      this.codeArr[key + 1].push(target)
      console.log(this.codeArr)
    },
    moveUp(key, index) {
      console.log(key, index)
      if (key == 0) {
        return false
      } else {
        const target = this.codeArr[key].splice(index, 1)[0]
        this.codeArr[key - 1].push(target)
        console.log(this.codeArr)
      }
    },
    copyLine(key) {
      this.$copyText(this.codeArr[key].join(',')).then(
        e => {
          console.log('复制行成功：', e);
        },
        e => {
          console.log('复制行失败：', e);
        }
      )
    },
    copyAll() {
      let str = ''
      this.codeArr.forEach(element => {
        str += element.join(',')
      })
      this.$copyText(str).then(
        e => {
          console.log('复制所有成功：', e);
        },
        e => {
          console.log('复制所有失败：', e);
        }
      )
    },
  },
  created() {
    const codes = this.codes || '000001,399001,399006,000300,000016,000688'
    this.originCodeArr = codes.split(',')
    this.codeArr = [[]]
    codes.split(',').forEach(element => {
      this.codeArr[0].push(element)
      // this.codeArr[0].push('' + this.code2market(element) + element + '')
    });

    // 阻止返回上一页，因为Macbook触摸板经常误触
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  }
}
</script>

<style>
body {
  font-family: Arial, 黑体, sans-serif;
}

.title {
  font-size: 14px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 4px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.chartline {
  display: flex;
  flex-direction: row;
  width: 30000px;
}

.chartline .box-card {
  display: block;
  position: relative;
}

.chartline .card-content {
  max-height: 608px;
  overflow: hidden scroll;
}

.card-content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.card-content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}

.card-content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.btn-top {
  float: right;
  padding: 3px 1px;
  margin: 0;
}

.green {
  color: green;
}

.red {
  color: red;
}

.bold {
  font-weight: bold;
}

.red-border {
  border: solid 1px red;
}

.green-border {
  border: solid 1px green;
}

.bold-border {
  border-width: 2px;
}

.red-bg {
  background-color: red;
  color: #fff;
  font-weight: normal;
}

.green-bg {
  background-color: green;
  color: #fff;
  font-weight: normal;
}
</style>